import verifyLeadingSlash from 'util/verifyLeadingSlash'
import verifyLeadingLang from 'util/verifyLeadingLang'

export default function verifyLeadingSlashLang (string, lang) {
  return verifyLeadingLang(verifyLeadingSlash(string), lang)
}



// WEBPACK FOOTER //
// ./client/util/verifyLeadingSlashLang.js